/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Whether to be shown for the circular, the linear or both views
 * @export
 */
export const PlasmidViewFilterConstants = {
    Circular: 'Circular',
    Linear: 'Linear',
    Both: 'Both'
} as const;
export type PlasmidViewFilterConstants = typeof PlasmidViewFilterConstants[keyof typeof PlasmidViewFilterConstants];


export function PlasmidViewFilterConstantsFromJSON(json: any): PlasmidViewFilterConstants {
    return PlasmidViewFilterConstantsFromJSONTyped(json, false);
}

export function PlasmidViewFilterConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlasmidViewFilterConstants {
    return json as PlasmidViewFilterConstants;
}

export function PlasmidViewFilterConstantsToJSON(value?: PlasmidViewFilterConstants | null): any {
    return value as any;
}

